import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Compass = function Compass(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 4c-1.3807 0-2.5 1.1193-2.5 2.5S10.6193 9 12 9s2.5-1.1193 2.5-2.5S13.3807 4 12 4m0 0V2m9 12.9375C18.8012 17.4287 15.5841 19 12 19c-3.584 0-6.8012-1.5713-9-4.0625m7.7448-6.2758L3 22M13.2552 8.6617 21 22"
    })
  }));
};
export default Compass;